import { Box, Grid, Stack, Typography } from "@mui/material"
import { allColors } from "../../constants"
import ServiceCard from "../../components/card/ServiceCard"
import { icons } from "../../assets"
import GlobalButton from "../../components/globalButton"


const SERVICES_DATA = [
    {
        icon: icons.saasSoftwareDevelopmentIcon,
        title: "SaaS Software Development",
        description: "Our expertise in web development allows us to build custom solutions that are powerful and tailored to your needs.We turn complex challenges into elegant, digital experiences.",
        services: [
            "ERP",
            "CRM",
            "MVP",
            "SAAS",
            "Cloud Solutions",
            "Web Development",
        ]
    },
    {
        icon: icons.mobileDevelopmentIcon,
        title: "Mobile Application Development",
        description: "We design and develop native mobile apps for iOS and Android that captivate users and deliver high performance. Elevate your mobile strategy with impactful apps.",
        services: [
            "iOS",
            "Android",
            "React Native",
            "Flutter",
            "Xamarin",
            "NativeScript",
        ]
    },
    {
        icon: icons.uiuxIcon,
        title: "UI / UX Design & Prototyping",
        description: "With over 400 projects under our belt, we craft intuitive and visually stunning UI/UX designs that engage users and drive results. Your vision deserves a design that shines.",
        services: [
            "Wire Framing",
            "Prototyping",
            "Designing",
            "Figma",
            "Sketch",
        ]
    },
    {
        icon: icons.graphicDesignIcon,
        title: "Graphic Design",
        description: "We’ve developed more than 300 sales funnels, generating over $20 million for our clients. Our funnels are expertly crafted to boost conversions and fuel your business growth.",
        services: [
            "Illustrator",
            "Canva",
            "Photoshop",
            "Premiere Pro",
            "After Effects",
        ]
    },
    {
        icon: icons.seoAndDigitalIcon,
        title: "SEO & Digital markting",
        description: "Boost your online presence with our targeted SEO & Digital marketing  strategies. We drive the right traffic to your site, helping you stand out and grow in the digital landscape.",
        services: [
            "SEO",
            "Google Ads",
            "Meta Ads",
            "Link Building",
            "Digital Marketing",
            "Social Media Marketing",
            "Email Marketing",
            "Content Marketing",
            "Social Media Marketing",
        ]
    },
    {
        icon: icons.fullStackIcon,
        title: "Full Stack Development",
        description: "Get powerful full-stack development that delivers seamless performance and scalable solutions for your business.",
        services: [
            "MERN",
            "Next.js",
            "React.js",
            "Node.js",
            "Express",
            "MongoDB",
        ]
    },
]

const Services = () => {
    return (
        <Box
            component={"section"}
            id="development-services"
            mt={{ xs: 4, sm: 6, md: 8 }}
            sx={{
                position: "relative",
                pb: 2,
                boxShadow: "inset 0px -43px 103px -100px rgba(0, 0, 0, 0.55)",
            }}
        >
            <Typography
                textAlign="center"
                fontFamily="Raleway"
                fontWeight="400"
                color={allColors.jetBlack}
                fontSize={{ xs: "35px", md: "50px" }}
            >
                Our Services
            </Typography>

            <Grid mt={2} container spacing={2} alignItems="stretch">
                {SERVICES_DATA.map((service) => (
                    <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                        <ServiceCard
                            icon={service.icon}
                            title={service.title}
                            description={service.description}
                            services={service.services}
                        />
                    </Grid>
                ))}
            </Grid>

            <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                <GlobalButton
                    variant={"outlined"}
                    title="Lets Discuss"
                    handleClickBtn={() => {
                        document
                            .getElementById("development-service-contact-us")
                            ?.scrollIntoView({ behavior: "smooth", block: "start" });
                    }}
                    style={{
                        color: allColors.silverSand,
                        borderColor: allColors.silverSand,
                        borderRadius: "2px",
                        height: "50px",
                        width: { xs: "100%", md: "150px" },
                    }}
                    hoverProperties={{
                        borderColor: allColors.silverSand,
                        backgroundColor: "transparent",
                        color: allColors.silverSand,
                    }}
                />
            </Stack>
        </Box>
    )
}

export default Services;